import { Link } from 'gatsby';
import { Text, TextVariant } from 'hem-ui';
import React, { ReactNode, Suspense } from 'react';
import getSlug from 'speakingurl';

import { content, headline } from './SectionTitle.module.scss';

const ReactMarkdown = React.lazy(() => import('react-markdown'));

type Props = {
  titleTag: 'h1' | 'h2' | 'h3' | 'h4';
  border: boolean;
  title: ReactNode;
  markdown?: string;
};

export const SectionTitle: React.FC<Props> = ({
  titleTag,
  border,
  title,
  markdown,
}) => (
  <div className={border ? 'mb-2 border-b border-black-100 pb-4' : headline}>
    <Text
      tag={titleTag}
      variant={TextVariant.HEADLINE_SECTION}
      id={getSlug(title.toString(), { truncate: 20 })}
    >
      {title}
    </Text>
    {!!markdown && (
      <Suspense fallback={<div className={content}>{markdown}</div>}>
        <div className={content}>
          <ReactMarkdown
            components={{
              p: ({ children }) => (
                <Text tag="p" variant={TextVariant.BODY_SMALL}>
                  {children}
                </Text>
              ),
              a: ({ href, children }) => <Link to={href}>{children}</Link>,
            }}
          >
            {markdown}
          </ReactMarkdown>
        </div>
      </Suspense>
    )}
  </div>
);
